import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fullScreen",
  "use": "fullScreen-usage",
  "viewBox": "0 0 57.08 57.08",
  "content": "<symbol viewBox=\"0 0 57.08 57.08\" id=\"fullScreen\"><title>资源 5</title><g id=\"fullScreen_图层_2\" data-name=\"图层 2\"><g id=\"fullScreen_图层_1-2\" data-name=\"图层 1\"><path d=\"M49.94,0H7.13A7.42,7.42,0,0,0,0,7.43V50a7.09,7.09,0,0,0,7.09,7.09H50A7.09,7.09,0,0,0,57.08,50V7.43A7.42,7.42,0,0,0,49.94,0Zm3.59,21.4h0V49.94a3.9,3.9,0,0,1-3.89,3.59H7.46a3.9,3.9,0,0,1-3.89-3.59V21.4h0v-14A3.87,3.87,0,0,1,7.13,3.57H49.94a3.87,3.87,0,0,1,3.59,3.86Z\" /><path d=\"M8.22,20.41h4.06V12.28h8.13V8.22H8.22Zm28.45-8.13h8.13v8.13h4.06V8.22H36.67Zm8.13,32.51H36.67v4.06H48.86V36.67H44.79ZM12.28,36.67H8.22V48.86H20.41V44.79H12.28Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fullScreen.svg
// module id = kVC+
// module chunks = 264